export default __webpack_public_path__ + "static/media/CNo.34-1.93250ebc.jpg";